import React from 'react'
import {
  IconPhone,
  IconMoodSad,
  IconClipboardText,
  IconMail,
  IconMessage,
  IconDeviceMobile,
} from '@tabler/icons-react'
import { isNumber, isEmpty } from 'lodash'

import { Loader } from '@/components/loaders/Loader'
import { Pill } from '@/components/pills/Pill'
import { CHANNEL_TYPE } from '@/utils/constants'

import { ExternalCallIdsLink } from '../components/ExternalCallIdsLink'

const showDisplayValue = (value, callIds, isPercent) => {
  if (isPercent) {
    // Backend returns 100% score if 0 calls are evaluated. Show N/A instead
    if (isEmpty(callIds)) {
      return 'N/A'
    }

    return `${value.toFixed(2) || 0}%`
  }

  return isNumber(value) ? Number(value).toLocaleString() : value || '0'
}

export const OverviewIcon = ({ noData, type, channelType }) => {
  if (noData) {
    return <IconClipboardText />
  }

  if (type === 'neutral') {
    switch (channelType) {
      case CHANNEL_TYPE.EMAIL:
        return <IconMail />
      case CHANNEL_TYPE.SMS:
        return <IconDeviceMobile />
      case CHANNEL_TYPE.CHAT:
        return <IconMessage />
      case CHANNEL_TYPE.CALL:
      default:
        return <IconPhone />
    }
  }

  if (type === 'negative') {
    return <IconMoodSad />
  }

  return <IconClipboardText />
}

export const OverviewCard = ({
  title,
  type,
  value,
  callIds,
  isPercent,
  loading,
  showLink,
  channelType,
  icon: customIcon,
}) => {
  const dataTestId = `overview-card-${title.split(' ').join('-').toLowerCase()}`
  const noData = isEmpty(callIds)
  const isStatusIcon = !noData && !type && isPercent

  return (
    <div className="overview-card" data-testid={dataTestId}>
      <Pill
        brand={!noData && type === 'neutral'}
        caution={!noData && type === 'negative'}
        success={isStatusIcon && value > 80}
        warning={(!noData && type === 'warning') || (isStatusIcon && value > 50 && value <= 80)}
        critical={isStatusIcon && value <= 50}
        circular
        icon={customIcon || <OverviewIcon noData={noData} type={type} channelType={channelType} />}
        data-testid={`${dataTestId}-icon`}
      />
      {loading ? (
        <Loader />
      ) : !isEmpty(callIds) && showLink ? (
        <ExternalCallIdsLink
          id={dataTestId}
          callIds={callIds}
          label={showDisplayValue(value, callIds, isPercent)}
          channelType={channelType}
        />
      ) : (
        <h2 data-testid={`${dataTestId}-value`}>{showDisplayValue(value, callIds, isPercent)}</h2>
      )}

      <h3 data-testid={`${dataTestId}-title`}>{title}</h3>
    </div>
  )
}
